/* ============================================================================
   PDP out-of-stock supply-options overlay — client sync.

   The server renders the correct overlay state on full page loads (main-product.liquid
   stamps `data-oos` on `.oos-overlay` from the selected variant). But when a shopper
   switches variant in-page, the theme's ProductInfo.handleUpdateProductInfo (theme.js)
   only swaps a fixed allowlist of element IDs — it does NOT touch this overlay. So we
   subscribe to the theme's `variantChange` pubsub event and toggle the overlay ourselves.

   We mutate attributes/text in place (rather than replacing the notify button) so the
   Klaviyo back-in-stock binding on `.klaviyo-bis-trigger` is preserved across switches.
   ============================================================================ */
(function () {
  // The picker snippet enqueues this script, so it can appear more than once on a page
  // (e.g. quick-view modal + main PDP). Subscribe only once.
  if (window.__lsOosOverlayInit) return;
  window.__lsOosOverlayInit = true;

  function boot() {
    if (!window.theme || !theme.pubsub || !theme.pubsub.PUB_SUB_EVENTS || !theme.pubsub.PUB_SUB_EVENTS.variantChange) {
      window.setTimeout(boot, 50);
      return;
    }

    theme.pubsub.subscribe(theme.pubsub.PUB_SUB_EVENTS.variantChange, function (payload) {
      var data = payload && payload.data;
      if (!data || !data.variant) return;

      var scope = document.getElementById('shopify-section-' + data.sectionId) || document;
      var overlays = scope.querySelectorAll('[data-oos-overlay]');
      var available = data.variant.available === true;

      overlays.forEach(function (overlay) {
        overlay.toggleAttribute('data-oos', !available);

        var content = overlay.querySelector('.oos-overlay__content');
        if (content) content.toggleAttribute('aria-hidden', !available);

        var card = overlay.querySelector('.oos-overlay__card');
        if (card) card.setAttribute('aria-hidden', String(available));

        var notifyBtn = overlay.querySelector('[data-oos-notify]');
        if (notifyBtn && data.variant.id) notifyBtn.setAttribute('data-variant-id', data.variant.id);
      });

      // Purchase buttons (Skio) live in a separate block — blur/disable them in sync.
      scope.querySelectorAll('[data-oos-plans]').forEach(function (wrap) {
        wrap.toggleAttribute('data-oos', !available);
      });
    });
  }

  boot();
})();
